import { useLocale } from '@components/Contexts/LocaleContext';
import Link from 'next/link';
import React, { ReactNode } from 'react';

interface ErrorModalProps {
  show: boolean;
  onClose: () => void;
  children: ReactNode;
}

const ErrorModal: React.FC<ErrorModalProps> = ({ show, onClose, children }) => {
  const { lang } = useLocale();

  if (!show) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-xl shadow-lg max-w-md w-full p-8 relative animate-fade-in">
        <button
          aria-label="Close"
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 text-2xl"
          onClick={onClose}
        >
          ×
        </button>
        <div className="flex flex-col items-center">
          <div className="mb-4">
            <svg width="48" height="48" fill="none" viewBox="0 0 24 24">
              <circle cx="12" cy="12" r="10" fill="#f87171" />
              <path
                d="M12 7v5m0 4h.01"
                stroke="#fff"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </div>
          {children}
          <button
            className="mt-2 px-6 py-2 rounded bg-blue-600 text-white font-medium hover:bg-blue-700 transition"
            onClick={onClose}
          >
            {lang === 'en' ? 'Close' : 'ปิด'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorModal;
